import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { TableContentForMasterCardTagReport } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { MasterCardLeafCollectionTagSchemaObject } from "../MasterCardLeafTagReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../Pages/tableFooter.css';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';

const screenCode = "MASTERCARDTAGCOLLECTIONREPORT";

export function MasterCardLeafCollectionTagReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [collectionTypes, setCollectionTypes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [total, setTotal] = useState({
        totalWeight: 0,
        totalNetWeight: 0
    });

    const [leafCollectionDetails, setLeafCollectionDetails] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        collectionTypeID: "0",
        fromDate: "",
        toDate: "",
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        collectionType: "0",
        fromDate: "",
        toDate: "",
    });

    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});
    const [footerTotal, setFooterTotal] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(MasterCardLeafCollectionTagSchemaObject).options({ allowUnknown: true });
    const [contentRowNames, setContentRowNames] = useState([]);
    const [tableHeaders, setTableHeaders] = useState([]);

    const [csvHeaders, setCsvHeaders] = useState([]);
    const [reportData, setReportData] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [leafCollectionDetails.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown(),
            getCollectionTypesForDropDown()
        )
    }, [leafCollectionDetails.factoryID])

    function handleGroupChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: target.value,
            factoryID: "0",
            routeID: "0",
            collectionTypeID: "0",

        });
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            factoryID: target.value,
            routeID: "0",
            collectionTypeID: "0",
        });
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: target.value,
        });
    }

    function handleCollectiontypeChange(target) {

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            collectionTypeID: target.value
        });
    }

    function handleFromDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            fromDate: target.value,
        });
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            toDate: target.value,
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, MasterCardLeafCollectionTagSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWMASTERCARDTAGCOLLECTIONREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(leafCollectionDetails.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(leafCollectionDetails.factoryID);
        setRoutes(data);
    }

    async function getCollectionTypesForDropDown() {
        const data = await services.getAllCollectionTypesByoperationEntityID(leafCollectionDetails.factoryID);
        setCollectionTypes(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {

        e.preventDefault();
        setIsTableHide(true);

        const errorMessages = validate(schema, leafCollectionDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(leafCollectionDetails);

        const result = await services.getMasterCardLeafTagReportData(leafCollectionDetails);

        var tableData = [];
        var columnDates = [];
        var headers = [];
        var uniqColDates = [];

        columnDates.push("collectionPointName");
        headers.push("Route Names");
        result.forEach(x => {
            uniqColDates.push(x.weightReadTime.split("T")[0].slice(5).replace(/-/g, "/"));

        });

        result.forEach(x => {
            var formattedTime = x.weightReadTime.split("T")[0].slice(5).replace(/-/g, "/")
            if (tableData.length === 0) {
                tableData.push({
                    collectionPointName: x.collectionPointName,
                    collectionPointID: x.collectionPointID,
                    [formattedTime]: x.tagCount,
                    total: x.tagCount
                });
            } else {
                var filterdRecord = tableData.find(y => y.collectionPointID === x.collectionPointID);

                if (filterdRecord) {
                    filterdRecord[formattedTime] = (filterdRecord[formattedTime] === undefined ? 0 :
                        filterdRecord[formattedTime]) + x.tagCount;
                    filterdRecord.total += x.tagCount;
                } else {
                    tableData.push({
                        collectionPointName: x.collectionPointName,
                        collectionPointID: x.collectionPointID,
                        [x.weightReadTime.split("T")[0].slice(5).replace(/-/g, "/")]: x.tagCount,
                        total: x.tagCount
                    });
                }
            }
        });

        columnDates.push(...[... new Set(uniqColDates)]);
        columnDates.push("total");
        headers.push(...[... new Set(uniqColDates)]);
        headers.push("Total");
        setContentRowNames(columnDates);
        setTableHeaders(headers);

        var copyOfCsvHeaders = [];

        columnDates.forEach(x => {
            if (x !== "total") {
                copyOfCsvHeaders.push({ label: x, value: x });
            } else {
                copyOfCsvHeaders.push({ label: "Total", value: "total" });
            }
        });

        if (result.length > 0) {
            calculateTotalFooter(result, tableData);

            setIsTableHide(false);
            setReportData(tableData);
            setCsvHeaders(copyOfCsvHeaders);
            createDataTable();
        }
    }

    function calculateTotalFooter(data, tableData) {

        var copyOfTableData = _.cloneDeep(tableData);
        var totalValues = [];
        var fullTotal = 0;

        data.forEach(x => {
            var formattedTime = x.weightReadTime.split("T")[0].slice(5).replace(/-/g, "/");
            fullTotal = parseInt(fullTotal) + parseInt(x.tagCount);
            if (totalValues.length === 0) {
                totalValues.push({
                    date: formattedTime,
                    total: x.tagCount
                });
            } else {
                var filterdRecord = totalValues.find(y => y.date === formattedTime);
                if (filterdRecord) {
                    filterdRecord.total += x.tagCount;
                } else {
                    totalValues.push({
                        date: formattedTime,
                        total: x.tagCount
                    });
                }
            }
        });

        totalValues.push({
            date: "total",
            total: fullTotal
        });

        var csvTotalRow = {collectionPointName: "Total"};
        totalValues.forEach(x => {
            csvTotalRow[x.date] = x.total;
        });
        csvTotalRow.total = fullTotal;
        copyOfTableData.push(csvTotalRow);
        copyOfTableData.unshift({}, {
            collectionPointName: "Date: " + new Date().toLocaleString() + ", User: " + tokenService.getUserNameFromToken()
        }, {})

        setFooterTotal(totalValues);

        setCsvData(copyOfTableData);
    }

    function createDataTable() {
        $('#masterCardLeafTagTable').DataTable();
    }

    function createFile() {
        var settings = {
            sheetName: 'Master Card Tag Report',
            fileName: 'MasterCardLeafTagReport',
            writeOptions: {}
        }
        xlsx(csvHeaders, csvData, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: "0",
            collectionTypeID: "0",
            toDate: "",
            fromDate: ""
        });
        setIsTableHide(true);
        setErrors("");
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            collectionType: collectionTypes[searchForm.collectionTypeID],
            fromDate: searchForm.fromDate,
            toDate: searchForm.toDate
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Master Card Leaf Collection Tag Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={leafCollectionDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={leafCollectionDetails.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={leafCollectionDetails.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4">
                                        <InputLabel shrink id="">Collection type</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionTypeID"
                                            id="collectionTypeID"
                                            name="collectionTypeID"
                                            value={leafCollectionDetails.collectionTypeID}
                                            onChange={(e) => handleCollectiontypeChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Collection type--</MenuItem>
                                            {generateDropDownMenu(collectionTypes)}
                                        </Select>
                                        {errors["collectionTypeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionTypeID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md-4">
                                        <InputLabel shrink id="searchDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md-4">
                                        <InputLabel shrink id="searchDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, leafCollectionDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div>
                                                <table id="masterCardLeafTagTable"
                                                style={{ display: "block" ,overflowX: "auto", whiteSpace: "nowrap", 
                                                maxWidth: "1400px", borderColor: "white" }}>
                                                    <thead>
                                                        <tr>
                                                            {
                                                                tableHeaders.map((x, index) => {
                                                                    return (
                                                                        <th key={index}>{x}</th>
                                                                    );
                                                                })
                                                            }
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <TableContentForMasterCardTagReport
                                                            data={reportData}
                                                            contentRowNames={contentRowNames}
                                                            hasEdit={false}
                                                        />
                                                    </tbody>
                                                    <tfoot>
                                                        <tr style={{ fontWeight: "bold" }}>
                                                            <th >Total</th>
                                                            {footerTotal.map((x, index) => {
                                                                return (
                                                                    <th key={index} style={{textAlign: "right"}}>{x.total}</th>
                                                                );
                                                            })}
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Master Card Leaf Collection Tag Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} footerTotal={footerTotal}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} tableHeaders={tableHeaders} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
